import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c0fa714"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ant-col-xs-order-24 ant-col-xl-order-24" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_6 = { class: "ss-tela-titulo" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Controle de Parâmetros", -1))
const _hoisted_8 = { class: "atalhos" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Remover dos Meus Atalhos", -1))
const _hoisted_10 = {
  style: {"color":"orange","font-size":"20px"},
  class: "anticon"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Adicionar aos Meus Atalhos", -1))
const _hoisted_12 = { class: "anticon" }
const _hoisted_13 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4",
  style: {"padding-top":"4px","padding-right":"10px"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Salvar Alterações", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "ss-tela-conteudo" }
const _hoisted_17 = { class: "ss-card ss-card-space" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESAS")
], -1))
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_22 = { class: "ss-categoria" }
const _hoisted_23 = { class: "ant-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_busca_avancada = _resolveComponent("busca-avancada")!
  const _component_parametros_campo = _resolveComponent("parametros-campo")!
  const _component_card = _resolveComponent("card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                (_ctx.storeSistema.getters.atalhoAdicionado(_ctx.state.identificadorRecurso, [_ctx.state.empresaSelecionada]))
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 0,
                      placement: "bottom"
                    }, {
                      title: _withCtx(() => [
                        _hoisted_9
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removerAtalho(_ctx.state.identificadorRecurso, [_ctx.state.empresaSelecionada])))
                        }, [
                          _createElementVNode("i", _hoisted_10, [
                            _createVNode(_component_icone, { nome: "estrela" })
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 1,
                      placement: "bottom"
                    }, {
                      title: _withCtx(() => [
                        _hoisted_11
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.adicionarAtalho(_ctx.state.identificadorRecurso, [_ctx.state.empresaSelecionada])))
                        }, [
                          _createElementVNode("i", _hoisted_12, [
                            _createVNode(_component_icone, { nome: "favorito" })
                          ])
                        ])
                      ]),
                      _: 1
                    }))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              style: {"margin-top":"4px","text-align":"center","width":"100%"},
              type: "button",
              class: "ant-btn ant-btn-primary ss-btn-tela",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmarSalvar()))
            }, _hoisted_15)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_a_select, {
                  value: _ctx.state.empresaSelecionada,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.empresaSelecionada) = $event)),
                  options: _ctx.telaBase.empresasDisponiveis,
                  style: {"width":"100%"},
                  optionFilterProp: "label",
                  onChange: _ctx.buscarParametros
                }, null, 8, ["value", "options", "onChange"])
              ])
            ]),
            _createVNode(_component_busca_avancada, {
              buscaAvancada: _ctx.state.buscaAvancada,
              "onUpdate:buscaAvancada": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.buscaAvancada) = $event)),
              empresas: [_ctx.state.empresaSelecionada],
              onAplicarFiltros: _ctx.buscarParametros
            }, null, 8, ["buscaAvancada", "empresas", "onAplicarFiltros"]),
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.grupos, (grupo, indexGrupo) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: indexGrupo,
                    class: "ant-row"
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(grupo.descricao), 1),
                      _createVNode(_component_a_tabs, { defaultActiveKey: "1" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupo.categorias, (categoria, indexCategoria) => {
                            return (_openBlock(), _createBlock(_component_a_tab_pane, {
                              key: indexCategoria,
                              tab: categoria.descricao
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_card, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_23, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoria.parametros, (parametro, indexParametro) => {
                                        return (_openBlock(), _createBlock(_component_parametros_campo, {
                                          key: indexParametro,
                                          empresa: _ctx.state.empresaSelecionada,
                                          parametro: _ctx.state.grupos[indexGrupo].categorias[indexCategoria].parametros[indexParametro],
                                          "onUpdate:parametro": ($event: any) => ((_ctx.state.grupos[indexGrupo].categorias[indexCategoria].parametros[indexParametro]) = $event)
                                        }, null, 8, ["empresa", "parametro", "onUpdate:parametro"]))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["tab"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}